import { SagaIterator } from 'redux-saga'
import { put } from 'redux-saga/effects'

import { lpActions } from '~state'

export function* onWeb3Set(): SagaIterator {
  yield put(lpActions.reset())
}
